import script from "./ClubHighlightExtList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubHighlightExtList.vue?vue&type=script&setup=true&lang=js"

import "./ClubHighlightExtList.vue?vue&type=style&index=0&id=56f52dff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56f52dff"]])

export default __exports__